import { PortalFooterContainer } from '@vs/ui/portal/footer';
import { useEnv } from '@vs/utils/envConfig';

export default function AppFooter() {
  const env = useEnv();
  const {
    appUrl: { legalDoc },
  } = env;
  return (
    <PortalFooterContainer>
      <a
        href={`${legalDoc}/privacy-policy`}
        target="_blank"
        rel="noreferrer"
        className="hover:underline"
      >{`Privacy Policy`}</a>
      <a
        href={`${legalDoc}/terms-of-use`}
        target="_blank"
        rel="noreferrer"
        className="hover:underline"
      >{`Terms of Use`}</a>
    </PortalFooterContainer>
  );
}
